import { createDocumentRequest } from './helper';
export const getGenericDocuments = createDocumentRequest({
    route: '/document/generic/documents',
    method: 'get',
    source: 'data',
});
